(() => {
  const RUT_ERROR = 'Ingresa un RUT válido para continuar con el pedido.';

  function cleanRut(value) {
    return (value || '').replace(/\./g, '').replace(/\s/g, '').replace(/-/g, '').toUpperCase();
  }

  function isValidRut(value) {
    const cleaned = cleanRut(value);
    if (!/^\d{7,8}[\dK]$/.test(cleaned)) return false;

    const body = cleaned.slice(0, -1);
    const verifier = cleaned.slice(-1);
    let sum = 0;
    let multiplier = 2;

    for (let index = body.length - 1; index >= 0; index -= 1) {
      sum += Number(body[index]) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const result = 11 - (sum % 11);
    const expected = result === 11 ? '0' : result === 10 ? 'K' : String(result);

    return expected === verifier;
  }

  function formatRut(value) {
    const cleaned = cleanRut(value);
    const match = cleaned.match(/^(\d{7,8})([\dK])$/);
    if (!match) return value.trim();

    const body = match[1].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${body}-${match[2]}`;
  }

  function getFields(form) {
    if (!form) return {};
    const input = form.querySelector('[data-cart-rut-input]') || document.querySelector(`[data-cart-rut-input][form="${form.id}"]`);
    const wrapper = input?.closest('[data-cart-rut-field]');
    const error = wrapper?.querySelector('[data-cart-rut-error]');

    return { input, error };
  }

  function setRutValidity(input, error, isValid) {
    if (!input) return;
    input.setAttribute('aria-invalid', isValid ? 'false' : 'true');
    input.setCustomValidity(isValid ? '' : RUT_ERROR);
    if (error) error.hidden = isValid;
  }

  async function saveRutAttribute(rut) {
    const response = await fetch(`${window.routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        attributes: {
          RUT: rut,
        },
      }),
    });

    if (!response.ok) throw new Error('Could not save RUT cart attribute.');
    return response.json();
  }

  function bindRutField(input, error) {
    if (input.dataset.rutFieldBound === 'true') return;
    input.dataset.rutFieldBound = 'true';

    input.addEventListener('input', () => {
      input.setCustomValidity('');
      input.setAttribute('aria-invalid', 'false');
      if (error) error.hidden = true;
    });

    input.addEventListener('blur', async () => {
      const formatted = formatRut(input.value);
      if (formatted) input.value = formatted;
      if (isValidRut(formatted)) {
        await saveRutAttribute(formatted).catch(() => {});
      }
    });
  }

  async function validateAndContinue(form, submitter) {
    const { input, error } = getFields(form);
    if (!input) return true;

    const formattedRut = formatRut(input.value);
    const valid = isValidRut(formattedRut);

    setRutValidity(input, error, valid);
    if (!valid) {
      input.focus();
      input.reportValidity();
      return false;
    }

    input.value = formattedRut;
    submitter?.setAttribute('aria-busy', 'true');
    submitter?.setAttribute('disabled', 'disabled');

    try {
      await saveRutAttribute(formattedRut);
      window.location.href = '/checkout';
      return true;
    } catch (errorToLog) {
      console.error(errorToLog);
      setRutValidity(input, error, false);
      input.focus();
      return false;
    } finally {
      submitter?.removeAttribute('aria-busy');
      submitter?.removeAttribute('disabled');
    }
  }

  function bindCartForm(form) {
    if (!form || form.dataset.rutValidationBound === 'true') return;
    const { input, error } = getFields(form);
    if (!input) return;

    form.dataset.rutValidationBound = 'true';
    bindRutField(input, error);

    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      if (submitter && submitter.name !== 'checkout') return;

      event.preventDefault();
      await validateAndContinue(form, submitter);
    });
  }

  function bindCheckoutButtons() {
    document.querySelectorAll('button[name="checkout"][form]').forEach((button) => {
      if (button.dataset.rutClickBound === 'true') return;
      button.dataset.rutClickBound = 'true';

      button.addEventListener('click', async (event) => {
        const form = document.getElementById(button.getAttribute('form'));
        const { input } = getFields(form);
        if (!input || isValidRut(input.value)) return;

        event.preventDefault();
        await validateAndContinue(form, button);
      });
    });
  }

  function bindCartRutValidation() {
    bindCartForm(document.getElementById('cart'));
    bindCartForm(document.getElementById('CartDrawer-Form'));
    bindCheckoutButtons();
  }

  document.addEventListener('DOMContentLoaded', bindCartRutValidation);
  document.addEventListener('cart:rut:bind', bindCartRutValidation);

  const observer = new MutationObserver(() => bindCartRutValidation());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
